import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, JsonPipe } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbCalendar, NgbDateStruct, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbModal, NgbModalOptions, NgbModule, NgbNav, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { LocationServiceService } from '../../Model/LocationMaster/location-service.service';
import { SessionService } from '../../Util/Session/session.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { first, Subject } from 'rxjs';
import { DataTablesModule } from 'angular-datatables';
import { SelectWorkOrderforReductionComponent } from '../select-work-orderfor-reduction/select-work-orderfor-reduction.component';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { AdditionOfManpowerService } from '../../Model/AdditionReductionOfManpower/addition-of-manpower.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../Model/Common/common.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { ViewofReductonConfirmationListComponent } from '../viewof-reducton-confirmation-list/viewof-reducton-confirmation-list.component';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-reduction-of-manpower',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, NgbDatepicker, DataTablesModule, JsonPipe, LoaderComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './reduction-of-manpower.component.html',
  styleUrl: './reduction-of-manpower.component.scss'
})
export class ReductionOfManpowerComponent {
  editMode: boolean = false
  isDisabled: boolean = false;
  Detail = {
    ESS_SiteMasterId: '',
    SelecteType: 1,
  }
  BranchMaster: any[] = [];
  DesignationLoad: any[] = [];
  Shift: any[] = [];
  ClientLoad: any[] = [];
  DutyLoad: any[] = [];
  SiteLoad: any[] = [];
  RedManpowerTable: any[] = [];
  NoOfEmp: number = 0;
  BranchId: number = 0;
  BranchName: string = '';
  ClientId: number = 0;
  ClientName: string = '';
  Designation: string = '';
  DesignationId: number = 0;
  ShiftTitle: string = '';
  ShiftID: number = 0;
  DutyId: number = 0;
  Duty: string = '';
  SiteId: number = 0;
  SiteName: string = '';
  dtTrigger: Subject<any> = new Subject<any>();
  WorkOrderNumber: string = '';

  selectedFile: File | null = null;
  displayedFileName: string | null = null;
  AllocationType: string = 'Reduction'
  WorkOrderDate: any;
  WorkOrderDateObj: any;
  public User: any = null;
  Image: any
  ImageUrl: any;
  EntryNo: number = 0;
  objdata = {
    editMode: false,
    AllocationType: '',
    Id: 0,
    wono: '',
    siteMode: false,
    bid: 0,
    cid: 0,
    sid: 0,
    Type: '',
    Auto: ''
  }
  CurrentDate: any = null
  dtoptions: DataTables.Settings = {};
  constructor(
    private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    private calendar: NgbCalendar,
    private siteadditionreduction: AdditionOfManpowerService,
    private utility: UtilityService,
    private dateFormate: CustomDateParserFormatter,
    private route: ActivatedRoute,
    protected common: CommonService,
    private tooltip: TooltipService,
    private router: Router
  ) {
    this.common.getPageRights();
    this.User = this.sessionService.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  async ngOnInit(): Promise<void> {
    // this.ComboLoad('Branch');
    // this.initializeComponent();
    // this.setupDataTableOptions();

    try {
      this.isDisabled = true
      await Promise.all([
        this.ComboLoad('Branch'),
        this.initializeComponent()
      ]);
      this.isDisabled = false
    } catch (error) {
      console.error('Error during initialization:', error);
    }

  }
  initializeComponent(): void {
    this.loadInitialData();
    this.handleQueryParams();
  }

  loadInitialData(): void {
    this.route.queryParams.subscribe(params => {
      this.setObjDataFromParams(params);
      if (this.objdata.siteMode) {
        this.Loadata();
      }
      if (this.objdata.editMode) {
        this.getData();
      }
    });
  }

  handleQueryParams(): void {
    this.route.queryParams.subscribe(params => {
      this.setObjDataFromParams(params);
    });
  }

  setObjDataFromParams(params: any): void {
    this.objdata = {
      editMode: params['editMode'],
      AllocationType: params['AllocationType'],
      Id: params['Id'],
      wono: params['wono'],
      siteMode: params['siteMode'],
      bid: parseInt(params['bid']),
      cid: parseInt(params['cid']),
      sid: parseInt(params['sid']),
      Type: params['Type'],
      Auto: params['Auto']
    };
  }

  async Loadata() {
    try {
      await this.ComboLoad('Branch');
      this.BranchId = this.objdata.bid;
      await this.ComboLoad('Client');
      this.ClientId = this.objdata.cid;
      await this.ComboLoad('Site');
      this.SiteId = this.objdata.sid;
    } catch (error) {
      console.error('Error loading data', error);
    }
  }
  CurDate(SelectType: string) {
    return this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': '', 'JoiningDate': '', }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.CurrentDate = response.Table[0].RegistrationDate;

        }
      },
      complete: () => { },
      error: (error) => { },
    });
  }
  onSelectChange(type: string) {
    if (type === 'Designation') {
      const selected = this.DesignationLoad.find(designation => designation.DesignationMasterID === this.DesignationId);
      this.Designation = selected ? selected.DesignationName : null;
      this.DutyId = 0
      this.Duty = ''
    }
    else if (type === 'Branch') {
      const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
      this.BranchName = selected ? selected.BranchName : null;
      this.ClientId = 0
      this.ClientName = ''
      this.SiteId = 0
      this.SiteName = ''
      this.DesignationId = 0
      this.Designation = ''
      this.DutyId = 0
      this.Duty = ''
    }
    else if (type == 'Client') {
      const selected = this.ClientLoad.find(site => site.ClientGroupMasterID === this.ClientId);
      this.ClientName = selected ? selected.ClientGroupName : null;
      this.SiteId = 0
      this.SiteName = ''
    }
    else if (type === 'Shift') {
      const selected = this.Shift.find(shift => shift.ShiftMasterID === this.ShiftID);
      this.ShiftTitle = selected ? selected.ShiftTitle : null;
    }
    else if (type === 'Duty') {
      const selected = this.DutyLoad.find(duty => duty.DutyMasterID === this.DutyId);
      this.Duty = selected ? selected.DutyName : null;
    }
    else if (type === 'Site') {
      const selected = this.SiteLoad.find(duty => duty.SiteMasterID === this.SiteId);
      this.SiteName = selected ? selected.SiteName : null;
      this.DesignationId = 0
      this.Designation = ''
    }
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.BranchId : 0,
      'ClientId': (Combotype == 'Site' || Combotype == 'Designation' || Combotype == 'Duty') ? this.ClientId : 0,
      'SiteId': (Combotype == 'Designation' || Combotype == 'Duty') ? this.SiteId : 0,
      'DesignationId': (Combotype == 'Duty') ? this.DesignationId : 0
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad.length >= 0) {
          if (Combotype == 'Branch') {
            this.BranchMaster = response.ComboLoad;
            const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
            this.BranchName = selected ? selected.BranchName : null;

          } else if (Combotype == 'Client') {
            this.ClientLoad = response.ComboLoad;
            const selected = this.ClientLoad.find(site => site.ClientGroupMasterID === this.ClientId);
            this.ClientName = selected ? selected.ClientGroupName : null;

          } else if (Combotype == 'Site') {
            this.SiteLoad = response.ComboLoad;
            const selected = this.SiteLoad.find(duty => duty.SiteMasterID === this.SiteId);
            this.SiteName = selected ? selected.SiteName : null;

          }
        }
        else {

        }
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  onFileSelected(event: any) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
    }
    if (this.selectedFile) {
      this.uploadToFTP(this.selectedFile);
      this.isDisabled = false;
    } else {
      this.isDisabled = false;
    }
  }
  removeFile() {
    this.selectedFile = null;
    this.displayedFileName = null;
    const fileInput = document.getElementById('formFileSm') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  }
  viewFile() {
    if (this.objdata.editMode) {
      window.open(this.ImageUrl, '_blank');
    }
    else {
      if (this.selectedFile) {
        window.open(URL.createObjectURL(this.selectedFile), '_blank');
      } else {
        console.error('No file selected or file is not available.');
      }
    }
  }


  openDetailWorkOrder() {
    if (!this.validateInputs()) {
      return;
    }
    const modalOptions: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      size: 'xl'
    };
    const modalRef = this.modalService.open(SelectWorkOrderforReductionComponent, modalOptions);
    modalRef.componentInstance.Id = this.SiteId;
    modalRef.result.then((result) => {
      for (const newEntry of result) {
        const exists = this.RedManpowerTable.some(entry => entry.RefESS_ShiftWiseManpowerDetailsId === newEntry.ESS_ShiftWiseManpowerDetailsId);
        if (exists) {
          this.toast.show({ message: `Site ${newEntry.SiteName} already exists.`, type: toastTypeEnum.warning });
          return
        } else {
          const essShiftWiseManpowerDetailsId = newEntry.ESS_ShiftWiseManpowerDetailsId;
          newEntry.RefESS_ShiftWiseManpowerDetailsId = essShiftWiseManpowerDetailsId;
          newEntry.ESS_ShiftWiseManpowerDetailsId = 0;
          this.RedManpowerTable.push(newEntry);
        }
      }
      this.toast.show({ message: 'Reduction Added in the List!', type: toastTypeEnum.success });
    }).catch((reason) => {
      console.log('Modal dismissed:', reason);
    });
  }

  refresh() {
    if (this.objdata.Type == 'V') {
      this.router.navigate(['master/ViewAllocateManpower']);
    }
    else {
      this.router.navigate(['master/sitewisemanpowersummary']);
    }
  }

  validateInputs(): boolean {
    if (this.WorkOrderNumber && !this.WorkOrderDate) {
      this.toast.show({ message: 'Please select Work Order Date', type: toastTypeEnum.warning });
      return false;
    }
    if (!this.BranchId || this.BranchId === 0) {
      this.toast.show({ message: 'Please select Branch!', type: toastTypeEnum.warning });
      return false;
    }
    if (!this.ClientId || this.ClientId === 0) {
      this.toast.show({ message: 'Please select Client!', type: toastTypeEnum.warning });
      return false;
    }
    if (!this.SiteId || this.SiteId === 0) {
      this.toast.show({ message: 'Please select Site!', type: toastTypeEnum.warning });
      return false;
    }
    return true;
  }

  async save() {
    await this.common.getPageRights();
    if (this.WorkOrderNumber && !this.WorkOrderDate) {
      this.toast.show({ message: 'Please select Work Order Date', type: toastTypeEnum.warning });
      return;
    }
    this.WorkOrderDateObj = this.dateFormate.format(this.WorkOrderDate);
    if (this.WorkOrderDate && !this.validateDateFormat(this.WorkOrderDateObj)) {
      this.toast.show({ message: 'Please enter Work Order Date in DDMMMYYYY Format!', type: toastTypeEnum.warning });
      this.WorkOrderDate = '';
      this.WorkOrderDateObj = '';
      return;
    }
    if (!this.BranchId || this.BranchId === 0) {
      this.toast.show({ message: 'Please select Branch!', type: toastTypeEnum.warning });
      return;
    }
    if (!this.ClientId || this.ClientId === 0) {
      this.toast.show({ message: 'Please select Client!', type: toastTypeEnum.warning });
      return;
    }
    if (!this.SiteId || this.SiteId === 0) {
      this.toast.show({ message: 'Please select Site!', type: toastTypeEnum.warning });
      return;
    }
    if (!this.objdata.editMode && this.RedManpowerTable.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Are you Sure want to save?'

    modalRef.result.then((result: any) => {
      if (result) {
        if (this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) {
          this.CheckManpowerValidation('WO');
        }
        else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      }
    }).catch(() => {

    });
  }

  CheckManpowerValidation(SelecType: string) {
    const manpower = this.RedManpowerTable.map(site => {
      return {
        DesignationId: site.DesignationId,
        DutyId: site.DutyId,
        ShiftId: site.ShiftId,
        FromDate: site.FromDate,
        ToDate: site.ToDate,
        NoOfPerson: site.NoOfPerson,
        RefESS_ShiftWiseManpowerDetailsId: site.RefESS_ShiftWiseManpowerDetailsId,
        Remarks: site.Remarks,
        ESS_ShiftWiseManpowerDetailsId: site.ESS_ShiftWiseManpowerDetailsId
      };
    });
    const validation = {
      SelectType: SelecType,
      ESS_ShiftWiseManpowerMasterId: this.objdata.Id,
      ESS_ShiftWiseManpowerDetails: manpower,
      AllocationType: this.objdata.AllocationType,
      WoNo: this.WorkOrderNumber,
      SiteId: this.SiteId,
    };

    this.siteadditionreduction.ESS_SiteManpowerValidation(validation).subscribe(
      data => {
        if (data.Table[0].Column1 === '01') {
          this.Insertupdate();
        } else {
          const modalRef = this.modalService.open(ViewofReductonConfirmationListComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Table1[0].Column1;
          modalRef.result.then((result: any) => {
            if (result) {
              this.Insertupdate();
            }
          }).catch(() => {

          });
        }
      }
    );
  }
  Insertupdate() {
    this.WorkOrderDateObj = this.dateFormate.format(this.WorkOrderDate);
    this.isDisabled = true
    const manpower = this.RedManpowerTable.length > 0 ? this.RedManpowerTable.map(site => {
      return {
        ESS_ShiftWiseManpowerDetailsId : site.ESS_ShiftWiseManpowerDetailsId, 
        DesignationId: site.DesignationId,
        DutyId: site.DutyId,
        ShiftId: site.ShiftId,
        FromDate: site.FromDate,
        ToDate: site.ToDate,
        NoOfPerson: site.NoOfPerson,
        RefESS_ShiftWiseManpowerDetailsId: site.RefESS_ShiftWiseManpowerDetailsId,
        Remarks: site.Remarks
      };
    }) : [];
    const additionData = {
      SelectType: this.objdata.editMode ? 'U' : 'I',
      ESS_ShiftWiseManpowerMasterId: this.objdata.Id,
      ESS_ShiftWiseManpowerDetailsId: '',
      ESS_ShiftWiseManpowerDetails: manpower,
      WoNo: this.WorkOrderNumber,
      WoDate: this.WorkOrderDateObj,
      SiteId: this.SiteId,
      UserID: this.User.UserId,
      AllocationType: 'R',
      Attachment: this.displayedFileName
    };
    this.siteadditionreduction.ESS_SiteManpowerAdditionReduction(additionData).subscribe(
      data => {
        if (data.Error_Code == '365' || data.Error_Code == '368') {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.isDisabled = false;
              if (this.objdata.Type == 'V') {
                this.router.navigate(['master/ViewAllocateManpower']);
              }
              else {
                this.router.navigate(['master/sitewisemanpowersummary']);
              }
            }
          });
        }
        else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = data.Error_Message;
          modalRef.result.then((result: any) => { });
        }
      },
      error => {
        console.error('Error:', error);
      });
  }

  uploadToFTP(file: File) {
    if (!file) {
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.utility.Upload({ 'DomainName': this.User.Domain, 'folder': 'AdditonOfManpower', 'CompanyCode': this.User.CompanyCode, 'FileBase64': reader.result }).subscribe((response: any) => {
        if (response.FileName != "") {
          // this.toast.show({ message: 'File uploaded successfully', type: toastTypeEnum.success });
          this.displayedFileName = response.FileName;
          this.ImageUrl = response.Url;

        } else {
          this.toast.show({ message: 'File not uploaded to FTP', type: toastTypeEnum.danger });
        }
        this.isDisabled = false;
      }, (error) => {
        console.error('FTP Upload Error:', error);
        this.isDisabled = false;
      });
    };
  }
  validateDateFormat(date: any) {
    const regex = /^\d{1,2} [A-Za-z]{3} \d{4}$/;
    return regex.test(date);
  }
  getData() {
    const data = {
      SelectType: 'S',
      ESS_ShiftWiseManpowerMasterId: this.objdata.Id,
      ESS_ShiftWiseManpowerDetailsId: '',
      AllocationType: this.objdata.AllocationType,
      WoNo: this.objdata.wono,
      SiteId: '',
      DesignationId: '',
      DutyId: '',
      ShiftId: '',
      AsOnDate: this.CurrentDate
    }
    this.isDisabled = true;
    this.siteadditionreduction.ESS_SiteManpowerAdditionReductionGet(data).subscribe(
      data => {
        if (data && data.Table && data.Table.length > 0) {
          this.RedManpowerTable = Object.values(data.Table);
          this.EntryNo = data.Table[0].EntryNo;
          this.WorkOrderNumber = this.objdata.wono;
          this.WorkOrderDate = this.dateFormate.parse(data.Table[0].WODate);
          this.displayedFileName = data.Table[0].Attachment;

          // this.ComboLoad('Branch');
          this.BranchId = data.Table[0].BranchId;
          const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
          this.BranchName = selected ? selected.BranchName : null;

          this.ComboLoad('Client');
          this.ClientId = data.Table[0].ClientId;
          const selected1 = this.ClientLoad.find(site => site.ClientGroupMasterID === this.ClientId);
          this.ClientName = selected1 ? selected1.ClientGroupName : null;

          this.ComboLoad('Site');
          this.SiteId = data.Table[0].SiteId;
          const selected2 = this.SiteLoad.find(duty => duty.SiteMasterID === this.SiteId);
          this.SiteName = selected2 ? selected2.SiteName : null;

          this.ImageUrl = this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + 'AdditonOfManpower' + '/' + data.Table[0].Attachment;
        }
        //this.isDisabled = false
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      },
      () => {
        this.isDisabled = false;
      }
    );
  }
  deleteRow(index: number): void {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you Sure want to Delete?'

    modalRef.result.then((result: any) => {
      if (result) {
        this.RedManpowerTable.splice(index, 1);
      }
    }).catch(() => {

    });
  }
}

